const _ = require("lodash");
const moment = require("moment");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const ProfileUtil = require("../../core/util/ProfileUtil");
const URLMake = require("../../../shared/URLMake");
const Link = require("../../core/view/Link");

const styles = require("./styles/MiniCalendar.css");

module.exports = createReactClass({
	displayName: "MiniCalendar",

	propTypes: {
		studentID: PT.number.isRequired,
		recentActivity: PT.object.isRequired,
	},

	renderWeekDays: function(recentActivity, dayOffset) {
		const cells = _.map(_.range(7), i => {
			const netOffset = 6 - i + dayOffset;
			let text = "";

			// If netOffset < 0, we're in the future
			if (netOffset >= 0) {
				const day = moment().subtract(netOffset, "day");
				const key = day.format("YYYY-MM-DD");
				const linkTo = URLMake.forParentStudent(this.props.studentID, {
					date: key,
					type: "activity",
				});
				const dayActivity = recentActivity[key];
				const timeData = dayActivity ? dayActivity.timeData : {};
				const inMinutes = ProfileUtil.getMinutesForTimeData(timeData);
				const dateNumber = day.format("D");

				text = ProfileUtil.getDurationVeryShortString(inMinutes);
				let cellClass = text ? styles.hasActivity : styles.noActivity;
				let dateEl = <div className={styles.day}>{dateNumber}</div>;
				if (netOffset >= 14) {
					// Older than 2 weeks from today
					cellClass = styles.past;
					dateEl = null;
					text = "";
				}
				if (netOffset === 0) {
					// Today
					cellClass += " " + styles.today;
				}
				return (
					<Link className={cellClass} key={"cell" + i} to={linkTo}>
						{dateEl}
						<div className={styles.dayData}>{text}</div>
					</Link>
				);
			} else {
				return (
					<div className={styles.future} key={"cell" + i}>
						{text}
					</div>
				);
			}
		});

		return <div className={styles.week}>{cells}</div>;
	},

	render: function() {
		const {recentActivity} = this.props;
		const days = ["S", "M", "T", "W", "T", "F", "S"];

		const weekdayCells = _.map(days, (day, i) => {
			return (
				<div className={styles.weekdayCell} key={"cell" + i}>
					{day}
				</div>
			);
		});

		const weekdayOffset = moment().day() - 6;

		return (
			<div className={styles.main}>
				<div className={styles.week}>{weekdayCells}</div>
				{this.renderWeekDays(recentActivity, weekdayOffset + 14)}
				{this.renderWeekDays(recentActivity, weekdayOffset + 7)}
				{this.renderWeekDays(recentActivity, weekdayOffset)}
			</div>
		);
	},
});
